// @flow strict

import React from 'react';

// Components
import Header from '../../components/Header';
import Pathways from './Internal/Pathways';

type PathwayType = {|
  image: string,
  alt: string,
  href: string,
  title: string,
  description: string,
|};

type PropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  featuredPathways: Array<PathwayType>,
  featuredTitle: string,
  featuredDescription: string,
  otherPathways: Array<PathwayType>,
  otherTitle: string,
  otherDescription: string,
|};

const PathwaysLanding = (props: PropTypes) => {
  const featured = {
    pathways: props.featuredPathways,
    title: props.featuredTitle,
    description: props.featuredDescription,
  };
  const other = {
    pathways: props.otherPathways,
    title: props.otherTitle,
    description: props.otherDescription,
  };
  return (
    <>
      <Header title={props.title} subtitle={props.subtitle}>
        {props.intro}
      </Header>
      <Pathways featured={featured} other={other} />
    </>
  );
};

export default PathwaysLanding;
